import React from 'react';
import {injectIntl, intlShape} from 'react-intl';
import ContactsList from './ContactsList'
import NewGroupSelectedParticipants from './NewGroupSelectedParticipants'
import MainBtn from './MainBtn'

class NewGroupParticipantsSelect extends React.Component {
  
  render(){
    return(
      <div className={ "new-group-participants-select " + 
        this.propsDependentCssClasses() }>
        <NewGroupSelectedParticipants
          contacts={this.props.contacts}
          selection={this.props.selection}
          onRemoveContactClick={this.props.onRemoveParticipantClick}
        />
        <ContactsList
          onContactClick={this.props.onAddParticipantClick}
          showNewGroupBtn={false}
        />
        { this.renderMainBtn() }
      </div>
    );
  }

  propsDependentCssClasses(){
    let classes = "";
    if( this.props.selection.length > 0 ){
      classes += "new-group-small-contacts-list";
    }
    return classes;
  }

  renderMainBtn(){
    if( this.props.selection.length > 0 ){
      return (
        <MainBtn onClick={this.props.onSubmit} glyphicon="arrow-right" />
      );
    }
    else{
      return(<div></div>)
    }
  }

}

export default injectIntl(NewGroupParticipantsSelect);